export const DeepThoughtColor = '#00f5ec';
export const ZiggyColor = '#e6007a';
export const JarvisColor = '#e69600';
export const FridayColor = '#26e600';